<template>
  <section class="btn_main_wrap">
    <p class="btn-title">
      {{ title }}
      <a v-if="lightBoxCopy.title" class="info-button_popin" @click="togglePopin">
        <svg class="icon-info_small">
          <use xlink:href="#icon-Info_small" />
        </svg>
      </a>
    </p>
    <ul class="btn-multi-choice btn_wrap" :data-tracking-id="dtmTitle">
      <template v-for="(item, index) in list">
      <li  :key="index" v-if="item.data">
        <a
          class="btn"
          :class="`${whichButtonIsActive(item.data)}`"
          @click="updateActiveButton(item.data)"
          :data-tracking-label="index"
          v-html="item.title"></a>
      </li>
      </template>
    </ul>
    <lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
  props: {
    title: String,
    list: Object,
    active: [String, Number],
    lightBoxCopy: Object,
    dtmTitle: String
  },
  data() {
    return {
      lightboxVisible: false,
      ActiveItem: this.active,
      lengthObj: ""
    };
  },
  components: {
    Lightbox
  },
  computed: {
    ...mapState({})
  },
  watch: {
    active: function(val) {
      this.ActiveItem = val;
    }
  },
  methods: {
    dynamicTrackingBtn() {},
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    },
    // fetch which button is active
    whichButtonIsActive(item) {
      if (item == this.ActiveItem) {
        return "active";
      }
    },
    // User click on a button
    updateActiveButton(item) {
      // check if its already active
      if (item === this.ActiveItem) {
        return;
      }
      // update the Object list
      this.ActiveItem = item;
      // Emit the object list to the parent div
      this.$emit("event_parent", this.ActiveItem);
    }
  }
};
</script>